import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterModule } from '@angular/router'

import { DetailKpiCard } from '../models/detail-page.model'

/**
 * Single KPI tile. Lives standalone so any surface can render one
 * without going through `<app-detail-kpi-row>`.
 *
 * The row component renders this in a flex grid; consumers building a
 * different layout (e.g. one tile in a sidebar, or KPIs interleaved with
 * text) can compose `<app-detail-kpi-card>` directly.
 */
@Component({
    selector: 'app-detail-kpi-card',
    standalone: true,
    imports: [CommonModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-kpi-card.component.html',
    styleUrls: ['./detail-kpi-card.component.scss']
})
export class DetailKpiCardComponent {
    @Input({ required: true }) card!: DetailKpiCard
    @Output() linkClicked = new EventEmitter<DetailKpiCard>()

    onLink(): void {
        this.linkClicked.emit(this.card)
    }

    subClass(tone: string | undefined): string {
        switch (tone) {
            case 'good':  return 'detail-kpi-sub good'
            case 'over':  return 'detail-kpi-sub over'
            case 'under': return 'detail-kpi-sub under'
            default:      return 'detail-kpi-sub muted'
        }
    }
}
